import { useEffect, useState } from "react";

export function useWindowEventState(eventName, getState) {
  const [state, setState] = useState(getState);

  useEffect(() => {
    const handler = (event) => setState({ ...getState(), ...(event?.detail || {}) });
    window.addEventListener(eventName, handler);
    return () => window.removeEventListener(eventName, handler);
  }, [eventName, getState]);

  return [state, setState];
}
